import { getPortalNotifications } from '../api/portal-service';

/**
 * The unread count the header's bell shows, shared with the portal so the two never disagree.
 *
 * The portal page writes the count whenever its own copy changes, and the bell polls between
 * visits. Either write is the server's number or a decrement the server has already accepted, so
 * whichever lands last is right.
 */
let current = 0;

const listeners = new Set<() => void>();

export function subscribeToUnreadNotifications(listener: () => void): () => void {
    listeners.add(listener);

    return () => {
        listeners.delete(listener);
    };
}

export function getUnreadNotifications(): number {
    return current;
}

/** Nothing is unread where there is no customer: the prerendered header is a signed-out one. */
export function getServerUnreadNotifications(): number {
    return 0;
}

export function setUnreadNotifications(count: number): void {
    if (count === current) {
        return;
    }

    current = count;

    for (const listener of listeners) {
        listener();
    }
}

/** A failed read keeps the last count: a network blip is not a reason to hide the badge. */
export async function refreshUnreadNotifications(signal?: AbortSignal): Promise<void> {
    try {
        const notifications = await getPortalNotifications(signal);
        setUnreadNotifications(notifications.unreadCount);
    } catch {
        // A 401 has already cleared the session, and the bell goes with it.
    }
}
